export const getBrandThemeNameFromId = (
  brandId: number | null,
  forceTheme?: BrandTheme,
): BrandTheme => {
  if (forceTheme) {
    return forceTheme;
  }

  if (brandId === null) {
    return 'default';
  }

  const brandThemeMap: Record<number, BrandTheme> = {
    0: 'default', // default
    4: 'hope', // hope education
    26: 'atoz', // atoz
    3: 'davies', // Davis sport
    24: 'gls', // gls
    9: 'international', // international
    29: 'findel', // findel
    8: 'lda', // lda
    7: 'philip', // Philip Harris
    23: 'spa', // Spa4
    22: 'punchout',
  };

  return brandThemeMap[brandId] ?? 'default';
};

export const getBrandIdFromUrl = (hostName: string | null): number => {
  if (!hostName) {
    return 0;
  }

  switch (true) {
    case hostName.includes('hope'):
      return 4;
    case hostName.includes('gls'):
      return 24;
    case hostName.includes('atoz'):
      return 26;
    case hostName.includes('davies'):
      return 3;
    case hostName.includes('ldalearning'):
      return 8;
    case hostName.includes('pharris'):
      return 7;
    case hostName.includes('spa'):
      return 23;
    case hostName.includes('marketplace'):
    case hostName.includes('dryad'):
    case hostName.includes('international'):
    case hostName.includes('findel'):
      return 29;
    case hostName.includes('uat.fecom-web.com'):
    case hostName.includes('dev.fecom-web.com'):
      return 24;
    case hostName.includes('punchout'):
      return 22;
    case hostName.includes('default'):
    default:
      return 0;
  }
};

export function getBrandNameFromHost(
  hostname?: string | null,
  forceTheme?: BrandTheme,
) {
  if (forceTheme) {
    return forceTheme;
  }

  if (!hostname) {
    return 'Fecom';
  }

  switch (true) {
    case hostname.includes('default'):
      return 'Default';
    case hostname.includes('hope'):
      return 'Hope';
    case hostname.includes('atoz'):
      return 'AtoZ Supplies';
    case hostname.includes('davies'):
      return 'Davies Sports';
    case hostname.includes('ldalearning'):
      return 'LDA Resources';
    case hostname.includes('pharris'):
      return 'Philip Harris';
    case hostname.includes('spa'):
      return 'Spa4Schools';
    case hostname.includes('marketplace'):
    case hostname.includes('dryad'):
      return 'Findel Dryad';
    case hostname.includes('international'):
      return 'Findel International';
    case hostname.includes('findel'):
      return 'Findel Education';
    case hostname.includes('gls'):
    case hostname.includes('uat.fecom-web.com'):
    case hostname.includes('dev.fecom-web.com'):
      return 'GLS';
    case hostname.includes('punchout'):
      return 'Punchout';
    default:
      return 'Fecom';
  }
}
